import { render } from "./AboutAllUser.vue?vue&type=template&id=d3a8fd16"
import script from "./AboutAllUser.vue?vue&type=script&lang=js"
export * from "./AboutAllUser.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__